var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.catalogComponent,{key:_setup.componentKey,ref:"component",tag:"component",attrs:{"catalog-info":_vm.catalogInfo,"section-info":_vm.sectionInfo,"multisection-index":_vm.multisectionIndex}})
}
var staticRenderFns = []

export { render, staticRenderFns }